import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/* Auto-generated. Do not edit! */
/* eslint-disable */

const SvgLeaderboardThirdBadge = props => /*#__PURE__*/_jsxs("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 28,
  height: 45,
  viewBox: "0 0 28 45",
  fill: "rgb(0 0 0 / 60%)",
  ...props,
  children: [/*#__PURE__*/_jsx("circle", {
    cx: 14,
    cy: 19.5,
    r: 12,
    fill: "#4D4216"
  }), /*#__PURE__*/_jsx("path", {
    fill: "#4D4216",
    d: "M23.276 41.88c.311 1.557-1.23 2.84-2.704 2.25l-5.829-2.332a2 2 0 0 0-1.486 0l-5.829 2.331c-1.475.59-3.015-.691-2.704-2.249l1.796-8.979c.135-.679.904-1.019 1.53-.724A13.95 13.95 0 0 0 14 33.5c2.127 0 4.144-.475 5.95-1.324.625-.295 1.394.045 1.53.724z"
  }), /*#__PURE__*/_jsx("path", {
    fill: "#FFD863",
    d: "M13.385 25.692a7.2 7.2 0 0 1-1.792-.224q-.88-.224-1.504-.672l.576-1.984q.513.24 1.104.384.609.128 1.216.128.737 0 1.232-.192.497-.208.752-.56.256-.368.256-.832 0-.496-.272-.864-.271-.384-.816-.576-.527-.192-1.28-.192-.64 0-1.216.16l2.528-4.4.864.592h-4.72v-2.304h7.44L14.937 19.1l-.672-.768q1.072 0 1.888.48.817.464 1.264 1.264.464.8.464 1.776 0 1.04-.544 1.92-.528.88-1.552 1.408-1.008.512-2.4.512"
  })]
});
export default SvgLeaderboardThirdBadge;